export default "__VITE_ASSET__nKmi1PDI__"